import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // Specify 'mdi' to use Material Design Icons
  },
  theme: {
    light: true,
    themes: {
      light: {
        background: '#d0f0c0',
      }
    }
  }
});
